import { DashboardTile } from "components/Dashboard/DashboardTile";

import { useWasteOverviewState } from "../WasteOverviewContext";
import { ManagementMethodChart } from "./Charts/ManagementMethodChart";

export function ManagementMethodTile() {
  const {
    overviewState: { isPending },
  } = useWasteOverviewState();
  return (
    <DashboardTile size={12} sx={{ opacity: isPending ? 0.5 : 1 }}>
      <DashboardTile.Header
        title="Management Method"
        infoTooltip={
          "Shows waste totals across facilities per management method (the type of " +
          "hazardous waste management system used to treat, recover, or dispose of a " +
          "hazardous waste). Totals are calculated from vendor line items, but if no " +
          "vendor data is present, we will use e‑Manifest data."
        }
      />
      <DashboardTile.ContentArea width="100%">
        <ManagementMethodChart />
      </DashboardTile.ContentArea>
    </DashboardTile>
  );
}
